import PropTypes from 'prop-types';
import { Box, Typography } from "@mui/material";

PageHeader.propTypes = {
  title: PropTypes.string,
  action: PropTypes.node
}
export default function PageHeader({ title, action }) {
  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="h4">
        {title}
      </Typography>

      {action &&
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
          {action}
        </Box>
      }
    </Box>
  )
}